'use client';

import { __makeTemplateObject } from '../../../../../_virtual/_tslib.js';
import styled, { css } from 'styled-components';
import { colors } from '../../../../../Colors/index.js';

var ChildrenSearchFilterWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-right: 16px;\n    ", "\n"], ["\n    margin-right: 16px;\n    ", "\n"])), function (_a) {
    var isMobile = _a.isMobile;
    if (!isMobile) {
        return '';
    }
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            margin: 0;\n            p {\n                padding: 0 16px;\n            }\n        "], ["\n            margin: 0;\n            p {\n                padding: 0 16px;\n            }\n        "])));
});
var ChildrenItemWrapper = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject([""], [""])));
var ParentWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    ", "\n"], ["\n    ", "\n"])), function (_a) {
    var isBorder = _a.isBorder;
    if (!isBorder) {
        return '';
    }
    return css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n            border-bottom: 1px solid ", ";\n        "], ["\n            border-bottom: 1px solid ", ";\n        "])), colors.grey[90]);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

export { ChildrenItemWrapper, ChildrenSearchFilterWrapper, ParentWrapper };
//# sourceMappingURL=ChildrenSearchFilter.css.js.map
